import React, { useEffect, useState } from 'react';

// import PropTypes from 'prop-types';

import Login from '../Login/Login';

import './styles.scss';


export default function Chat() {

const [token, setToken] = useState(false);
const [connected, setConnected] = useState(false)

    useEffect(() => {
        const tokenString = sessionStorage.getItem('token');
        const userToken = JSON.parse(tokenString);

        if (userToken) {
            setConnected(true);
        }

        if (token) {
            sessionStorage.setItem('token', JSON.stringify(token));
            setConnected(true);
        }

        return () => {
            
        }
    },[token]);


    return (

        <div className='chat-wrapper'>
            {connected ? (
                <div className="chat">Chat</div>

            ) :
                (
                    <Login setToken={setToken} connected={connected}></Login>

                )
            }
        </div>
    );
}

// Chat.propTypes = {};